"use client";

import Script from "next/script";
import { useState, useEffect } from "react";

export default function CommentWidget() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    const isDevHost = host.includes("main") || host === "localhost";
    setShouldLoad(isDevHost);
  }, []);

  if (!shouldLoad) return null;

  return (
    <Script
      id="comment-widget"
      src="https://mantracollab-cdns.s3.ca-central-1.amazonaws.com/comment-widget.min.js"
      strategy="afterInteractive"
      onLoad={() => {
        console.log("Comment widget loaded (dev domain).");
      }}
      onError={() => {
        console.warn("Comment widget could not be loaded. This might be due to an adblocker or network issue.");
      }}
    />
  );
}
